import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover-v2'
import RenderIf from '@/components/ui/render-if'
import { Text } from '@/components/ui/text'
import { ICommissionSummary } from '@/data/referral'
import { useIsMd } from '@/hooks'
import { CommonArrowDropDown } from '@/icons'
import { cn } from '@/lib'
import { formatTokenAmount } from '@/utils'

import { TokenBalanceTable } from './TokenBalanceTable'

interface AvailableRewardTokenBalanceProps {
  commissionSummary?: ICommissionSummary
  isFetching?: boolean
}
export const AvailableRewardTokenBalance = ({ commissionSummary, isFetching }: AvailableRewardTokenBalanceProps) => {
  const isMd = useIsMd()
  const isShowTokenBalance = commissionSummary?.availableUsdValue && commissionSummary?.availableUsdValue > 0
  return (
    <Popover>
      <PopoverTrigger
        className={cn('flex items-center group cursor-text', {
          'cursor-pointer': isShowTokenBalance,
        })}
      >
        <Text size={18} isLoading={isFetching}>
          {formatTokenAmount(commissionSummary?.availableUsdValue || 0, 'USDT').slice(0, 5)}
        </Text>
        <RenderIf condition={isShowTokenBalance}>
          <CommonArrowDropDown
            size={24}
            className='size-6 transition-transform duration-300 group-data-[state=open]:rotate-180'
          />
        </RenderIf>
      </PopoverTrigger>
      <RenderIf condition={isShowTokenBalance}>
        <PopoverContent
          align='start'
          className='px-2 md:px-6 py-2 md:py-5 space-y-3 max-w-sm md:max-w-[30.5625rem]'
          alignOffset={isMd ? 0 : -68}
        >
          <TokenBalanceTable commissionSummary={commissionSummary} />
        </PopoverContent>
      </RenderIf>
    </Popover>
  )
}
